import { Box, Typography, Paper } from '@mui/material';

const VideoTile = () => {
  return (
    <Paper
      id="video-tile"
      elevation={3}
      sx={{
        padding: '15px',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: 'none',
      }}
    >
      <Typography
        sx={{
          fontWeight: '600',
          fontSize: 20,
          lineHeight: '24px',
          color: '#001030',
          textAlign: 'center',
        }}
      >
        What's new on AdvisoryCloud?
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '8px 0',
        }}
      >
        <iframe
          width="100%"
          height="186"
          src="https://player.vimeo.com/video/1076389631?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479&wmode=opaque"
          title="AdvisoryCloud Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ borderRadius: 12 }}
        />
      </Box>
    </Paper>
  );
};

export default VideoTile;
